// https://medium.com/angular-in-depth/how-to-improve-angular-performance-by-just-adding-just-8-characters-877bde708ddd
// https://github.com/medikoo/memoizee
// Apply only on PURE! methods
// Does not understand ES2015 default params
// Memoized methods that use 'this' scope in their body won't work correctly - may be possible
// to adapt, check docs or just provide as arguments
// Additional config possible, check docs

import * as memoizee from 'memoizee';

export function memoize() {
  return function (target, key, descriptor) {
    const oldFunction = descriptor.value;
    const newFunction = memoizee(oldFunction);
    descriptor.value = function () {
      return newFunction.apply(this, arguments);
    };
  };
}